import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, trackPageView } from './utils/analytics';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID;

const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (consent === 'accepted' && measurementId) {
      initGA(measurementId);
    }
  }, []);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (consent === 'accepted') {
      trackPageView(location.pathname);
    }
  }, [location]);
};

export default useAnalytics;
